import { useMemo } from 'react';

import { useEditorConfig } from '../../../shared/hooks/useEditorConfig';

type EditorConfig = Record<string, unknown>;

type Result = ModelHookResult<{
	editorConfig: EditorConfig;
}>;

const mergeEditorConfig = ({
	defaultEditorConfig,
	rteConfig,
}: {
	defaultEditorConfig: EditorConfig;
	rteConfig: EditorConfig;
}) => {
	const config = {
		...defaultEditorConfig,
		...rteConfig,
	};
	return config;
};

export function useRichTextEditorConfig({
	isBlurb,
	rteConfig,
}: {
	isBlurb: boolean;
	rteConfig?: EditorConfig;
}): Result {
	const {
		data: { customEditorConfig, blurbEditorConfig },
	} = useEditorConfig();

	const editorConfig = useMemo(() => {
		const defaultEditorConfig = isBlurb ? { ...customEditorConfig, ...blurbEditorConfig } : customEditorConfig;
		return rteConfig ? mergeEditorConfig({ defaultEditorConfig, rteConfig }) : defaultEditorConfig;
	}, [isBlurb, customEditorConfig, blurbEditorConfig, rteConfig]);

	return {
		data: {
			editorConfig,
		},
	};
}
